export default "__VITE_ASSET__Bsxf1dlT__"